import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg29 from "../../../assets/svg/svg29.svg";
import svg46 from "../../../assets/svg/svg46.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchCounties, fetchData } from "../../../features/fetch/fetchSlice";
import { cashConverter, extractYear, formatText } from "../../../utils";
import { setActiveObj } from "../../../features/obj/objSlice";
import FloodControlView from "./FloodControlView";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import moment from "moment";

function FloodControlTable() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "flood_control/fetch_floodcontrols";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { saving } = useSelector((state) => state.save);
  const { counties } = useSelector((state) => state.fetch);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [countyId, setCountyId] = useState(null);
  const [yearData, setYearData] = useState(null);
  
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "flood_control/fetch_floodcontrols",
        floodId: prodd?.floodId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        floodName: e.target.value == "" ? null : e.target.value,
        county: countyId,
        year: extractYear(yearData),
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "floodControl", data: prodd }));
    await navigate("/rob/flood-control-add");
  };
  const handleDisable = () => {};
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "floodControl", data: {} }));
    await navigate("/rob/flood-control-add");
  };
  const handleView = async () => {
    await showDrawer();
  };
  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg46} alt="svg46" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.floodName}
          </div>
        );
      },
      sorter: (a, b) => a.floodName.localeCompare(b.floodName),
    },

    {
      title: "Category",
      dataIndex: "flCategory",
      sorter: (a, b) => a.flCategory.localeCompare(b.flCategory),
    },
    {
      title: "County",
      dataIndex: "countyCode",
      sorter: (a, b) => a.countyCode.localeCompare(b.countyCode),
    },
    {
      title: "Budget",
      dataIndex: "floodCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.floodCost.localeCompare(b.floodCost),
    },
    {
      title: "Funding Source",
      dataIndex: "floodSourceFunds",
      sorter: (a, b) => a.floodSourceFunds.localeCompare(b.floodSourceFunds),
    },
    {
      title: "Start Date",
      dataIndex: "floodStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.floodStartDate).valueOf() - moment(b.floodStartDate).valueOf(),
    },
    {
      title: "Status",
      dataIndex: "floodStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          SILTED: "#3250FF",
          DECOMMISSIONED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

 
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

 
  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        county: countyId,
        year: extractYear(yearData),
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    dispatch(fetchCounties());
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [yearData, countyId]);

  const onFinish = () => {};

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb breadcrumbs={[{ title: "Flood Control" }]} />
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex lg:flex-row flex-col  lg:items-center justify-between gap-y-4">
          <div className="form-add-h">Available Flood Control</div>
          <div className="w-[150px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <img src={svg29} alt="svg29" />{" "}
              <span className="ml-1">Capture New</span>
            </button>
          </div>
        </div>

        <div className="flex items-center mt-[2.03rem] w-full gap-x-[1.25rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className="w-full  "
            form={form}
          >
            <div className="w-full flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
              <span className="">Select County</span>
              <Select
                className=""
                allowClear
                style={{
                  width: "100%",
                }}
                options={
                  counties?.length > 0 &&
                  counties?.map((item) => ({
                    value: item?.countyName,
                    label: item?.countyName,
                  }))
                }
                value={countyId}
                onChange={(value) => setCountyId(value)}
                placeholder="Select"
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label?.toLocaleLowerCase() ?? "").includes(
                    input?.toLocaleLowerCase()
                  )
                }
              />
              <DatePicker
                placeholder="Year"
                className="input !w-[31.1rem]"
                picker="year"
                value={yearData}
                onChange={(value) => setYearData(value)}
              />
            </div>
          </Form>

          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search dam..."}
            />
          </div>
        </div>

        <Table
          rowSelection={false}
          className="mt-[1.31rem] w-full"
          scroll={{
            x: 1200,
          }}
          rowKey={(record) => record?.floodId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>
      <FloodControlView onClose={onClose} open={openDrawer} prodd={prodd} />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default FloodControlTable;
